



















import { Component, Vue, Prop } from 'vue-property-decorator'
import { Button } from '@alpha/ink'

@Component({
  components: {
    Button
  }
})
export default class ConfirmationBubble extends Vue {
  @Prop({ required: true }) titleText!: string
  @Prop() descriptionText!: string
  @Prop({ default: 'CANCEL' }) cancelText!: string
  @Prop({ default: 'CONFIRM' }) confirmText!: string
  @Prop({ required: true }) cancelHandler!: any
  @Prop({ required: true }) confirmHandler!: any
}
